import Axios from "axios";
import classNames from "classnames";
import { UserQuery } from "generated/graphql";
import * as React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getFullName } from "Tools";
import { PublicPaths } from "Views/Paths";
import { useClickOutsideHandler } from "./Hooks/useClickOutsideHandler";

interface HeaderHamburgerProps {
  currentUser: NonNullable<UserQuery["user"]>;
}

const hamburgerMenuElementId = "hamburger-menu";

export const logOutAndRedirect = async () => {
  await Axios.get("/api/User/LogOut");
  window.location.href = PublicPaths.LogIn;
};

export function LoggedInHeaderHamburger(props: HeaderHamburgerProps) {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const ref = React.useRef(null);

  const toggleMenu = () => setMenuVisible(!isMenuVisible);

  useClickOutsideHandler({
    isHandlerActive: isMenuVisible,
    handleClickOutside: () => setMenuVisible(false),
    elementRef: ref,
  });

  return (
    <div
      className={classNames("dropdown has-text-left is-right", {
        "is-active": isMenuVisible,
      })}
      id={hamburgerMenuElementId}
      ref={ref}
    >
      <div className="dropdown-trigger">
        <button
          type="button"
          onClick={toggleMenu}
          style={{ padding: "12px", marginRight: "-12px" }}
          className="is-hidden-tablet"
        >
          <span className="icon" style={{ color: "white", fontSize: "22px" }}>
            <i className="fa fa-bars" />
          </span>
        </button>

        <button
          className="button is-hidden-mobile"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          onClick={toggleMenu}
        >
          <span>
            Hello, <b>{getFullName(props.currentUser)}</b>
          </span>
          <span className="icon is-small">
            <i className="fa fa-angle-down" aria-hidden="true" />
          </span>
        </button>
      </div>
      <div className="dropdown-menu" role="menu">
        <div className="dropdown-content">
          <span className="dropdown-item" style={{ cursor: "default" }}>
            {props.currentUser.email}
          </span>
          <hr className="dropdown-divider" />
          <Link to={PublicPaths.ChangePassword} className="dropdown-item">
            Change password
          </Link>
          <hr className="dropdown-divider" />
          <a
            href="/logOut"
            className="dropdown-item"
            onClick={e => {
              e.preventDefault();
              void logOutAndRedirect();
            }}
          >
            Log out
          </a>
        </div>
      </div>
    </div>
  );
}
